import cn from 'classnames'
import React from 'react'

interface Props {
  className?: string
  isSelected?: boolean
  onClick?: () => void
  children?: React.ReactNode
}

export const TabButton: React.FC<Props> = ({ className, isSelected, onClick, children }) => (
  <button
    className={cn('h-[50px]', { 'border-base border-solid border-b-[3px]': isSelected }, className)}
    onClick={onClick}
  >
    <span
      className={cn(
        'h-[18px] opacity-80 font-primary text-[15px] tracking-[0.5px] leading-[180x] text-center',
        { 'font-bold pt-[2px] text-bass': isSelected },
        { 'font-medium text-textdark': !isSelected },
      )}
    >
      {children}
    </span>
  </button>
)
